export default __webpack_public_path__ + "static/codeleap_logo_white-b68d1ccc4d91e287a5ddb8902cf8d0a8.png";